/* Nerivoa sections — media gallery (images + video), bundle picker, sticky add-to-cart */
(function () {
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function initGallery(root) {
    var main = root.querySelector('[data-nv-main]');
    if (!main) return;
    var slides = [].slice.call(main.querySelectorAll('[data-nv-slide]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-nv-thumb]'));
    var dots = [].slice.call(root.querySelectorAll('[data-nv-dots] i'));
    if (!slides.length) return;
    var i = 0, inView = false;

    function ytCmd(frame, func) {
      try { frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: [] }), '*'); } catch (e) {}
    }
    function vimeoCmd(frame, method, value) {
      try { var m = { method: method }; if (value !== undefined) m.value = value; frame.contentWindow.postMessage(JSON.stringify(m), '*'); } catch (e) {}
    }
    function pauseSlide(sl) {
      var v = sl.querySelector('video');
      if (v && !v.paused) { v.__nvSelf = true; v.pause(); }
      var f = sl.querySelector('iframe');
      if (f) { if (sl.getAttribute('data-host') === 'youtube') ytCmd(f, 'pauseVideo'); else vimeoCmd(f, 'pause'); }
    }
    function playSlide(sl) {
      var v = sl.querySelector('video');
      if (v) {
        if (v.__nvUser) return;
        v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        return;
      }
      var f = sl.querySelector('iframe');
      if (f && !f.__nvUser) {
        if (sl.getAttribute('data-host') === 'youtube') { ytCmd(f, 'mute'); ytCmd(f, 'playVideo'); }
        else { vimeoCmd(f, 'setVolume', 0); vimeoCmd(f, 'play'); }
      }
    }
    slides.forEach(function (sl) {
      var v = sl.querySelector('video');
      if (v) {
        v.addEventListener('pause', function () { if (v.__nvSelf) { v.__nvSelf = false; return; } if (!v.ended) v.__nvUser = true; });
        v.addEventListener('play', function () { v.__nvUser = false; });
      }
      var f = sl.querySelector('iframe');
      if (f) f.addEventListener('load', function () { if (slides[i] === sl && inView) playSlide(sl); });
    });
    function wake(sl) {
      if (!sl) return;
      sl.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
    }
    function show(n) {
      var prev = slides[i];
      i = (n + slides.length) % slides.length;
      slides.forEach(function (sl, k) {
        var on = k === i;
        sl.classList.toggle('is-on', on);
        if (on) sl.removeAttribute('aria-hidden'); else { sl.setAttribute('aria-hidden', 'true'); pauseSlide(sl); }
      });
      thumbs.forEach(function (x, k) {
        var on = k === i;
        x.classList.toggle('is-on', on);
        if (on) {
          x.setAttribute('aria-current', 'true');
          var bar = x.parentNode;
          if (bar && bar.scrollWidth > bar.clientWidth) bar.scrollTo({ left: x.offsetLeft - bar.offsetLeft - (bar.clientWidth - x.offsetWidth) / 2, behavior: 'smooth' });
        } else x.removeAttribute('aria-current');
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      wake(slides[i]); wake(slides[(i + 1) % slides.length]);
      if (inView && prev !== slides[i]) playSlide(slides[i]);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var p = root.querySelector('[data-nv-prev]'), nx = root.querySelector('[data-nv-next]');
    if (p) p.addEventListener('click', function () { show(i - 1); });
    if (nx) nx.addEventListener('click', function () { show(i + 1); });

    // swipe
    var sx = 0, sy = 0, tracking = false;
    main.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (!tracking || slides.length < 2) return; tracking = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) show(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
    main.addEventListener('keydown', function (e) {
      if (e.target.closest && e.target.closest('video')) return;
      if (e.key === 'ArrowLeft') show(i - 1); else if (e.key === 'ArrowRight') show(i + 1);
    });

    // autoplay the active video (muted) only while the gallery is on screen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        inView = en[0].isIntersecting;
        if (inView) playSlide(slides[i]); else pauseSlide(slides[i]);
      }, { threshold: 0.35 }).observe(main);
    } else { inView = true; playSlide(slides[i]); }

    // jump to the selected variant's image
    var sel = root.querySelector('[data-nv-variant]');
    if (sel) sel.addEventListener('change', function () {
      var mid = sel.options[sel.selectedIndex].getAttribute('data-media-id');
      if (!mid) return;
      for (var k = 0; k < slides.length; k++) if (slides[k].getAttribute('data-media-id') === mid) { show(k); break; }
    });
  }

  function initBundles(root) {
    var opts = root.querySelectorAll('[data-nv-opt]');
    var btns = root.querySelectorAll('[data-nv-add]');
    var priceEls = root.querySelectorAll('[data-nv-price]');
    var wasEls = root.querySelectorAll('[data-nv-was]');
    var saveEls = root.querySelectorAll('[data-nv-savepct]');
    var nameEls = root.querySelectorAll('[data-nv-bname]');
    var instEls = root.querySelectorAll('[data-nv-inst]');
    var err = root.querySelector('[data-nv-err]');
    var fmt = root.getAttribute('data-money-format');
    var cur = null;
    var sel = root.querySelector('[data-nv-variant]');
    var v0p = +root.getAttribute('data-v0-price') || 0, v0w = +root.getAttribute('data-v0-was') || 0;
    function variant() {
      if (!sel) return null;
      var op = sel.options[sel.selectedIndex];
      return { id: op.value, price: +op.getAttribute('data-price'), was: +op.getAttribute('data-was') };
    }
    if (sel) sel.addEventListener('change', function () { if (cur) pick(cur); });
    function pick(o) {
      cur = o;
      opts.forEach(function (x) { x.classList.toggle('is-on', x === o); var r = x.querySelector('input'); if (r) r.checked = x === o; });
      var price = +o.getAttribute('data-price'), was = +o.getAttribute('data-was');
      var vr = variant(), q = +o.getAttribute('data-qty') || 1;
      if (vr) { price = price + (vr.price - v0p) * q; was = was + (vr.was - v0w) * q; }
      priceEls.forEach(function (e) { e.textContent = money(price, fmt); });
      wasEls.forEach(function (e) { e.textContent = was > price ? money(was, fmt) : ''; });
      saveEls.forEach(function (e) {
        if (was > price) { e.textContent = 'SAVE ' + money(was - price, fmt).replace(/\.00(?=\D*$)/, ''); e.style.display = ''; }
        else e.style.display = 'none';
      });
      nameEls.forEach(function (e) { e.textContent = o.getAttribute('data-name'); });
      instEls.forEach(function (e) { e.textContent = money(Math.round(price / 4), fmt); });
    }
    opts.forEach(function (o) { o.addEventListener('click', function () { pick(o); }); });
    var start = root.querySelector('[data-nv-opt].is-on') || opts[0];
    if (start) pick(start);
    btns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (!cur) return;
        var ids = (cur.getAttribute('data-items') || '').split(',').filter(Boolean).map(function (x) { return x.split(':'); });
        var vr = variant();
        if (vr && ids.length) ids[0][0] = vr.id;
        var kit = cur.getAttribute('data-kit');
        var items = ids.map(function (x) { var it = { id: +x[0], quantity: +(x[1] || 1) }; if (kit) it.properties = { _kit: kit }; return it; });
        if (!items.length) return;
        btns.forEach(function (x) { x.disabled = true; });
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw r;
          if (window.nvCart && window.nvCart.open) {
            btns.forEach(function (x) { x.disabled = false; });
            window.nvCart.open(true);
          } else {
            window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
          }
        }).catch(function () {
          btns.forEach(function (x) { x.disabled = false; });
          if (err) { err.style.display = 'block'; err.textContent = 'Sorry, something went wrong adding this to your cart. Please try again.'; }
        });
      });
    });
  }

  function initSticky(root) {
    var bar = document.querySelector('[data-nv-sticky]');
    var anchor = root.querySelector('[data-nv-add]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    document.body.classList.add('nv-has-sticky');
    new IntersectionObserver(function (en) {
      var e = en[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(anchor);
  }

  // autoplaying background videos (hero etc.): only play while on screen to save mobile data/battery
  var vio = null;
  function initAutoVideos() {
    if (!('IntersectionObserver' in window)) return;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!vio) vio = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: 0.2 });
    document.querySelectorAll('.nv video[data-nv-auto]').forEach(function (v) {
      if (v.__nvIo) return; v.__nvIo = true; vio.observe(v);
    });
  }

  function init() {
    document.querySelectorAll('[data-nv-product]').forEach(function (root) {
      if (root.__nv) return; root.__nv = true;
      initGallery(root); initBundles(root); initSticky(root);
    });
    initAutoVideos();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
